import { render, staticRenderFns } from "./NonInteractiveAgreements.vue?vue&type=template&id=60977a3d&scoped=true&"
import script from "./NonInteractiveAgreements.vue?vue&type=script&lang=js&"
export * from "./NonInteractiveAgreements.vue?vue&type=script&lang=js&"
import style0 from "./NonInteractiveAgreements.vue?vue&type=style&index=0&id=60977a3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60977a3d",
  null
  
)

export default component.exports